module.exports = __webpack_public_path__ + "img/check-grey.6769fe9f.svg";